export default "dist/images/block-text-side-title-2.8fd0ffa.png";